// services/siddo.js — справочникът по СИДДО (config/siddo.config.json).
//
// Обвивката съществува, защото JSON се чете различно от двата свята:
// Vite (екранът) и чист Node ESM (тестовете) искат import-атрибут, а CJS
// require го чете навсякъде без церемонии. Екранът и тестовете внасят ТОЗИ
// модул, не JSON-а направо.
//
// В справочника rate е null НАВСЯКЪДЕ — калкулаторът не смята автоматично
// по СИДДО; стойностите в raw са само ориентир от вторичен източник.

const config = require('../config/siddo.config.json');

module.exports = {
  SIDDO: config,
  countries: config.countries,
  meta: config._meta,
};
